<mbs-modal [title]="(destination ? 'shared:modals.addDestinationBucket.edit' : 'shared:modals.addDestinationBucket.create') | i18next"
           [isCustomModal]="true"
           [loading]="loading"
           #modal>
  <ng-container modal-body>
    <ng-container *ngIf="destination?.isReadOnly">
      <mbs-alert [type]="popupType.warning"
                 [icon]="true">
        {{ 'shared:modals.addDestinationBucket.insufficientPermissionsToEditDestination' | i18next }}
      </mbs-alert>
    </ng-container>

    <mbs-alert *ngIf="errorText"
               [type]="popupType.danger"
               [icon]="true">
      {{ errorText }}
    </mbs-alert>

    <form [formGroup]="form">
      <div class="mbs-form-group">
        <mbs-input formControlName="displayBucketName"
                   [placeholder]="'shared:placeholders.displayName' | i18next: { format: 'capitalize' }"
                   [showRequiredMark]="false"
                   [boldLabel]="true"
                   [label]="'shared:common.displayName' | i18next: { format: 'capitalize' }"></mbs-input>
      </div>

      <div class="mbs-form-group">
        <mbs-input formControlName="bucketName"
                   [placeholder]="'shared:modals.addDestinationBucket.inputBucketName' | i18next: { format: 'capitalize', type: rootFolderName }"
                   [showRequiredMark]="false"
                   [boldLabel]="true"
                   [label]="'shared:modals.addDestinationBucket.existingRootFolder' | i18next: { format: 'capitalize', type: rootFolderName }"></mbs-input>
      </div>

      <div class="mbs-form-group">
        <h5 class="mb-0"
            [class.text-disabled]="destination?.isReadOnly">{{ 'shared:common.companies' | i18next: { format: 'title' } }}</h5>
        <div class="mb-2"
             [class.text-disabled]="destination?.isReadOnly">{{ 'shared:modals.addDestinationBucket.companyExplanation' | i18next }}</div>

        <mbs-company-select [multiple]="true"
                            formControlName="companies"
                            [selectedIds]="selectedCompanyIds"
                            appendTo=".modal-content">
        </mbs-company-select>
      </div>
    </form>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button [type]="'primary'"
                [disabled]="destination?.isReadOnly"
                (click)="onActionButtonClick()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button [type]="'secondary'"
                (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
